import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-inputgroup" }

import { useCreateRole } from "./useCreateRole";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateRole',
  setup(__props) {

const { loading, submit, form, hasError } = useCreateRole();

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: _unref(form).name.$value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name.$value) = $event)),
        placeholder: "Entrer le nom",
        class: _normalizeClass({ 'p-invalid': _unref(form).name.$hasError })
      }, null, 8, ["modelValue", "class"]),
      _createVNode(_component_Button, {
        disabled: _unref(hasError) || _unref(loading),
        loading: _unref(loading),
        type: "submit",
        label: "Créer le rôle personnalisé",
        icon: "pi pi-plus"
      }, null, 8, ["disabled", "loading"])
    ])
  ], 32))
}
}

})